/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { emailSend$Json } from '../fn/email/email-send-json';
import { EmailSend$Json$Params } from '../fn/email/email-send-json';
import { emailSend$Plain } from '../fn/email/email-send-plain';
import { EmailSend$Plain$Params } from '../fn/email/email-send-plain';
import { MenuDto } from '../models/menu-dto';

@Injectable({ providedIn: 'root' })
export class EmailService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `emailSend()` */
  static readonly EmailSendPath = '/api/Email/send-free-offer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emailSend$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  emailSend$Plain$Response(params?: EmailSend$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuDto>> {
    return emailSend$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `emailSend$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  emailSend$Plain(params?: EmailSend$Plain$Params, context?: HttpContext): Observable<MenuDto> {
    return this.emailSend$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuDto>): MenuDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `emailSend$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  emailSend$Json$Response(params?: EmailSend$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuDto>> {
    return emailSend$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `emailSend$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  emailSend$Json(params?: EmailSend$Json$Params, context?: HttpContext): Observable<MenuDto> {
    return this.emailSend$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuDto>): MenuDto => r.body)
    );
  }

}
